module.exports = __webpack_public_path__ + "static/img/ht_word_1.a57790d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/back_bg/ht_word_1.png
// module id = JUnw
// module chunks = 1